import { render, staticRenderFns } from "./data-management-overview.vue?vue&type=template&id=6303f8cd&scoped=true"
import script from "./data-management-overview.vue?vue&type=script&lang=ts"
export * from "./data-management-overview.vue?vue&type=script&lang=ts"
import style0 from "./data-management-overview.vue?vue&type=style&index=0&id=6303f8cd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6303f8cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6303f8cd')) {
      api.createRecord('6303f8cd', component.options)
    } else {
      api.reload('6303f8cd', component.options)
    }
    module.hot.accept("./data-management-overview.vue?vue&type=template&id=6303f8cd&scoped=true", function () {
      api.rerender('6303f8cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/data-management/data-management-overview.vue"
export default component.exports